export default __webpack_public_path__ + "static/3-8-0-0-dc5c0537ce799ab45401267bff7fa321.jpg";